import * as React from 'react';

import { AutocompleteProps } from '@lightspeed/flame/Autocomplete';
import cn from 'classnames';

import Autocomplete from '..';
import { getRegionList } from './utils';

const dropdownClass = 'cr-autocomplete-region';

const RegionAutocomplete: React.FC<AutocompleteProps> = (props) => {
  const {
    countryCode,
    regionCode,
    onChange,
    placeholder = 'Select a Region',
    className,
    ...rest
  } = props;

  const options = (getRegionList(countryCode) || []).reduce(
    (acc: { label: string; value: string }[], region) => {
      acc.push({
        label: region.regionName,
        value: region.regionCode,
      });

      return acc;
    },
    []
  );

  const selectClass = cn(dropdownClass, className);

  return (
    <div data-test="region-autocomplete">
      <Autocomplete
        aria-label="region-autocomplete-input"
        className={selectClass}
        {...rest}
        placeholder={placeholder}
        options={options}
        value={regionCode ? options.find((option) => option.value === regionCode) : null}
        onChange={onChange}
      />
    </div>
  );
};

export default RegionAutocomplete;
